const SHIB = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="9.99995" cy="10.2334" r="9.75947" fill="#F00500" />
    <path
      d="M12.604 6.33329C12.1316 6.17382 10.9598 5.85489 10.0526 5.85489C8.93277 5.85489 7.80235 6.10295 7.37712 6.22698C5.69033 4.29921 4.38271 3.6519 3.93975 3.56921C2.99004 5.12844 3.80392 8.19963 4.32957 9.54032C3.8807 10.3613 3.03256 12.3363 3.23101 13.6687C3.47907 15.3342 6.57979 18.435 10.1589 18.435C13.738 18.435 16.449 15.2634 16.6261 13.6687C16.7679 12.393 16.0237 10.3849 15.6339 9.54032C16.8104 6.05334 16.4667 4.16573 16.1477 3.65781C14.872 3.67198 13.2537 5.44737 12.604 6.33329Z"
      fill="#FFA409"
    />
    <path
      d="M7.77025 9.50308C7.62399 9.08571 7.30649 8.82975 6.86951 8.88326C6.43254 8.93677 6.1159 9.1731 6.1159 9.65915C6.1159 10.1452 6.54398 10.1675 7.02111 10.1318C7.49824 10.0962 7.95307 10.0248 7.77025 9.50308Z"
      fill="white"
    />
    <path
      d="M10.1589 18.435C13.738 18.435 16.4489 15.2634 16.6261 13.6688C15.9022 13.4576 14.1276 13.3787 12.8211 14.7522C12.7048 13.9054 11.9808 12.2117 10.0154 12.2117C8.05007 12.2117 7.2051 13.9054 7.02829 14.7522C6.66032 14.2672 5.38569 13.3715 3.23096 13.6688C3.47902 15.3343 6.57974 18.435 10.1589 18.435Z"
      fill="white"
    />
    <path
      d="M12.9198 8.88326C12.4828 8.82975 12.1653 9.08571 12.019 9.50308C11.8362 10.0248 12.291 10.0962 12.7682 10.1318C13.2453 10.1675 13.6734 10.1452 13.6734 9.65915C13.6734 9.1731 13.3567 8.93677 12.9198 8.88326Z"
      fill="white"
    />
    <path
      d="M4.63388 8.5868C4.3021 7.86794 3.73806 6.07948 4.13621 4.67651C4.57067 4.75551 5.68134 5.22632 6.64824 6.47762C6.22169 6.6988 5.22164 7.43031 4.63388 8.5868Z"
      fill="#FF8300"
    />
    <path
      d="M15.185 8.5868C15.5168 7.86794 16.0808 6.07948 15.6827 4.67651C15.2482 4.75551 14.1376 5.22632 13.1707 6.47762C13.5972 6.6988 14.5973 7.43031 15.185 8.5868Z"
      fill="#FF8300"
    />
    <path
      d="M8.47939 12.1367C8.47528 11.9355 8.16892 11.3447 7.21271 10.9307C6.25656 10.5166 5.97807 10.5062 5.92878 10.5103C5.85897 10.6335 5.74643 10.981 5.85487 11.3851C6.26599 11.7006 7.38955 12.3964 8.47939 12.1367Z"
      fill="black"
    />
    <path
      d="M11.491 12.1367C11.4951 11.9355 11.8014 11.3447 12.7576 10.9307C13.7138 10.5166 13.9923 10.5062 14.0416 10.5103C14.1114 10.6335 14.2239 10.981 14.1155 11.3851C13.7044 11.7006 12.5808 12.3964 11.491 12.1367Z"
      fill="black"
    />
    <path
      d="M10.3165 14.8683C10.8042 14.7856 11.1756 14.3611 11.1756 13.8499V13.6616C11.1756 13.4086 10.9705 13.2036 10.7176 13.2036H9.56762C9.3147 13.2036 9.10966 13.4086 9.10966 13.6616V13.8499C9.10966 14.3962 9.5338 14.8435 10.0707 14.8804L9.84157 15.6307L8.37495 15.5608L8.99772 16.6608L9.06753 15.8286C9.49625 15.8945 10.5376 15.9869 11.2733 15.8286L11.3781 16.6608C11.5643 16.2941 11.9309 15.5608 11.9077 15.5608C11.8844 15.5608 11.0017 15.6074 10.5633 15.6307L10.3188 14.8683H10.3165Z"
      fill="black"
    />
    <path
      d="M10.7495 16.0555H9.46913L9.68445 16.3174L9.84157 16.1836L10.1384 16.4804L10.4119 16.1836L10.5633 16.3174L10.7495 16.0555Z"
      fill="black"
    />
  </svg>
);
export default SHIB;
